import { Tree } from "fluid-framework";
import { useCallback, useSyncExternalStore } from "react";

import { getTable } from "../fluid.service.js";
import { useFluid } from "./use-fluid.js";

export const useFluidTable = (tableId: string) => {
  const { sharedTree } = useFluid();
  const subscribe = useCallback(
    (onStoreChange: () => void) =>
      Tree.on(sharedTree.root.tables, "treeChanged", onStoreChange),
    [sharedTree]
  );
  const getSnapshot = useCallback(
    () => getTable({ sharedTree, tableId }),
    [sharedTree, tableId]
  );

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};
